export const getDefaultRecipeServings = (
  data: { default_servings?: number },
  override_servings?: number
): number => {
  const { default_servings } = data;

  if (!default_servings) {
    return override_servings || 1;
  }

  if (!override_servings) {
    return default_servings || 1;
  }

  return Math.max(default_servings, override_servings);
};
